import React, { useEffect, useState } from 'react';

import "./Conjunto.css";

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ConjuntoColumnList } from './ConjuntoConstants';
import JsonEdit from '../../components/JsonEdit';

function Conjunto(props) {
    const { conjuntoId } = props;

    const [selectedConjunto, setSelectedConjunto] = useState();

    const moduleData = useSelector((state) => state.conjunto);

    const { t } = useTranslation();

    useEffect(() => {
        if (conjuntoId) {
            const selConjunto = moduleData?.conjuntoList?.find(ad => ad.id === conjuntoId);
            setSelectedConjunto(selConjunto);
        }

    }, [conjuntoId]);

    const renderItem = (ccl) => {
        return (
            <div className='item' key={`info-item-${ccl.dbname}`}>
                <div className='title'>{t(ccl.label)}:</div>
                {
                    ccl.type === 'json' && <JsonEdit value={selectedConjunto[ccl.dbname]} edit={true} />
                }
                {
                    ccl.type !== 'json' &&
                    <div className='content'>{selectedConjunto[ccl.dbname]}</div>
                }
            </div>
        )
    }

    return (
        <div
            className="modal"
            id={`conjunto_detail_modal`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog  modal-xl modal-administrator" >

                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="backDropModalTitle">{selectedConjunto?.nombre} Info</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='module-info-container'>
                            <div className='module-info-data' >
                                {
                                    selectedConjunto && ConjuntoColumnList().filter(ccl => ccl.form === true).map(ccl => (renderItem(ccl)))
                                }
                            </div>
                            <div className='conjunto-info-administradores'>
                                <div className='box-title'>
                                    Administrador
                                </div>
                                <div className='box-content'>
                                    <div className='empty'>EN EL MOMENTO NO TIENE REGISTRADO NINGUN ADMINISTRADOR</div>
                                </div>
                                <div className='box-button'>
                                    <div className='btn btn-primary'>Adicionar</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default Conjunto;